import axios from "./axios.interceptors";
import { CouponRequestBody, PagedCouponsList } from "app/types/service-types/CouponTypes";
import { PagedReservationsList } from "app/types/service-types/ReservationTypes";

class CouponServices {
  async getCoupons(
    params: { page?: number; size?: number } = {}
  ): Promise<PagedCouponsList> {
    const response = await axios.get("/api/admin/coupons", { params });
    return response.data;
  }

  async getReservationsWithCoupon(
    params: { page?: number; size?: number; couponCode?: string } = {}
  ): Promise<PagedReservationsList> {
    const response = await axios.get("/api/reservations/coupon-discount", {
      params,
    });
    return response.data;
  }

  createCoupon = async (body: CouponRequestBody): Promise<any> => {
    // matches POST /api/admin/coupons
    return await axios.post("/api/admin/coupons", body);
  };
}

export default new CouponServices();
